// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BePs","questions":"styles_questions__38vEC","footer":"styles_footer__3XJj2"};